const giftSvg = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 3.5H3.75C3.41848 3.5 3.10054 3.3683 2.86612 3.13388C2.6317 2.89946 2.5 2.58152 2.5 2.25C2.5 1.91848 2.6317 1.60054 2.86612 1.36612C3.10054 1.1317 3.41848 1 3.75 1C5.5 1 6 3.5 6 3.5ZM6 3.5H8.25C8.58152 3.5 8.89946 3.3683 9.13388 3.13388C9.3683 2.89946 9.5 2.58152 9.5 2.25C9.5 1.91848 9.3683 1.60054 9.13388 1.36612C8.89946 1.1317 8.58152 1 8.25 1C6.5 1 6 3.5 6 3.5ZM6 3.5L6 11M1 7H11M1 5.1L1 9.4C1 9.96005 1 10.2401 1.10899 10.454C1.20487 10.6422 1.35785 10.7951 1.54601 10.891C1.75992 11 2.03995 11 2.6 11L9.4 11C9.96005 11 10.2401 11 10.454 10.891C10.6422 10.7951 10.7951 10.6422 10.891 10.454C11 10.2401 11 9.96005 11 9.4V5.1C11 4.53995 11 4.25992 10.891 4.04601C10.7951 3.85785 10.6422 3.70487 10.454 3.60899C10.2401 3.5 9.96005 3.5 9.4 3.5L2.6 3.5C2.03995 3.5 1.75992 3.5 1.54601 3.60899C1.35785 3.70487 1.20487 3.85785 1.10899 4.04601C1 4.25992 1 4.53995 1 5.1Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`

//on dom load
function swatchesInit() {

    const swatches = document.querySelectorAll('.free-gift .swatch');
    Array.from(swatches).forEach((swatch, index) => {
        swatch.addEventListener('click', async function () {

            const selected = document.querySelector('.free-gift .swatch.selected');
            if (selected) {
                selected.classList.remove('selected');
            }
            swatch.classList.add('selected');

            // Set cart atribute
            const inputAtribute = document.querySelector('.gift-product-input');
            if(inputAtribute) inputAtribute.value = swatch.dataset.value;

            // remove gift title
            const giftTitle = document.querySelector('.free-gift-title')
            if (giftTitle) giftTitle.style.display = 'none';
            // remove other swatches
            swatches.forEach((swatch, indexc) => {
                if (indexc !== index) swatch.style.display = 'none';
            });
            // show trash icon
            const trashIcon = document.querySelector('.free-gift .gift-trash');
            trashIcon.style.display = 'block';

            // make background white and change icon
            const giftContainer = document.querySelector('.free-gift-container');
            const freeGiftIconContainer = document.querySelector('.free-gift-title');
            const freeGiftIcon = document.querySelector('.free-gift-title svg');
            const hrELement = document.querySelector('.free-gift-container hr');

            freeGiftIconContainer.classList.remove('big');
            giftContainer.style.backgroundColor = 'white';
            freeGiftIcon.outerHTML = giftSvg;
            hrELement.style.display = 'block';


        });
    });

}

function swatchesRestart() {

    // Show all swatches
    const swatches = document.querySelectorAll('.free-gift .swatch');
    Array.from(swatches).forEach((swatch) => {
        swatch.style.display = 'block';
    });

    // Remove selected class to swatch
    const selected = document.querySelector('.free-gift .swatch.selected');
    if (selected) selected.classList.remove('selected');

    // Hide trash icon
    const trashIcon = document.querySelector('.free-gift .gift-trash');
    if (trashIcon) trashIcon.style.display = 'none';

    // SHow gift title
    const giftTitle = document.querySelector('.free-gift-title')
    if (giftTitle) giftTitle.style.display = 'block';

    // class input atribute
    const inputAtribute = document.querySelector('.gift-product-input');
    if(inputAtribute) inputAtribute.value = undefined;

}